type On404Options<T> = { returnValue: T };

export function on404<T, RV>({ returnValue }: On404Options<RV>) {
  return function (_target: unknown, _propertyKey: string, descriptor: TypedPropertyDescriptor<(...args: any[]) => Promise<{ data: T | RV }>>) {
    const fn = descriptor.value;

    descriptor.value = async function (...args: Parameters<Required<typeof descriptor>['value']>) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const result = fn!.call(this, ...args);
      if (result && 'code' in result && result.code === 404) return { data: returnValue };

      return result;
    };
  };
}
